import api from '@/plugins/api'
import { userVL } from '@/configs/endpoints'
import requestValidation from '@/configs/requestValidation'
const store = 'user'

export default {
  state: () => ({
    userList: [],
    userCount: 0,
    user: null,
    errorUser: false
  }),
  mutations: {
    DELETE_MEDIA (state, data) {
      let index = state.user.files.findIndex(e => e.id === data)
      if (index !== -1) {
        state.user.files.splice(index, 1)
      }
    }
  },
  actions: {
    async getUserList (context, filter) {
      const params = new URLSearchParams()
      for (let field in filter) {
        filter[field] && params.append(field, filter[field])
      }
      const response = await api.get(`${userVL.user}?${ params }`)
      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'userList', data: response.data.results })
        context.commit('SET_DATA', { store, state: 'userCount', data: response.data.count })
        return response.data
      }
      return false
    },
    async getUser (context, id) {
      const response = await api.get(userVL.userChange(id))
      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'user', data: response.data })
      }
      return false
    },
    async createUser (context, body) {
      const response = await api.post(userVL.user, { body: body })
      if ([400, 500].includes(response.code)) context.commit('SET_DATA', { store, state: 'errorUser', data: true })
      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'user', data: response.data })
        context.commit('ADD_DATA', { store, state: 'userList', data: response.data })
        context.commit('SET_DATA', { store, state: 'errorUser', data: false })
        return response.data
      }
      return false
    },
    async updateUser (context, body) {
      const response = await api.patch(userVL.userChange(body.id), { body: body })
      if ([400, 500].includes(response.code)) context.commit('SET_DATA', { store, state: 'errorUser', data: true })
      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'user', data: response.data })
        context.commit('UPDATE_DATA', { store, state: 'userList', data: response.data })
        context.commit('SET_DATA', { store, state: 'errorUser', data: false })
        return response.data
      }
      return false
    },
    uploadUserMedia (context, data) {
      return Promise.all(data.items.map(async item => {
        const body = new FormData()
        body.append('type_file', item.type)

        item.files.forEach(file => {
          body.append('files', file)
        })
        return await api.post(userVL.userMedia(data.id), { body: body })
      })).then(response => response.every(async r => await requestValidation(r)))
    },
    async updateUserMedia (context, data) {
      return Promise.all(data.items.map(async item => {
        const body = new FormData()
        body.append('type_file', item.type)

        item.files.forEach(file => {
          body.append('files', file)
        })
        return await api.put(userVL.updateUserMedia(data.id), { body: body })
      })).then(response => response.every(async r => await requestValidation(r)))
    },
    async deleteUserMedia (context, data) {
      const response = await api.delete(userVL.deleteUserMedia(data))
      if (await requestValidation(response)) {
        context.commit('DELETE_MEDIA', data.fileId)
        return true
      }
      return false
    },

    async refreshUserPassword (context, id) {
      return await api.post(userVL.refreshPassword(id))
    }
  }
}
